import { defineMessages } from "react-intl";

const messages = defineMessages({
  success: {
    id: "fileStorage.components.success",
    defaultMessage: "Success!",
  },
  successDetail: {
    id: "fileStorage.components.success.detail",
    defaultMessage: "This record has been updated successfully.",
  },
});

export default messages;
